import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import utils from '@/utils/utils';
import store from '@/store';
export function createWaterMark(file) {
  return new Promise(function (resolve) {
    fileByBase64(file).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(base64) {
        var _store$state, _store$state$globalSt, _store$state$globalSt2;
        var tempCanvas, _yield$utils$getLocat, address, week, canvas, img, newFile;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return imgToCanvas(base64);
              case 2:
                tempCanvas = _context.sent;
                _context.next = 5;
                return utils.getLocation();
              case 5:
                _yield$utils$getLocat = _context.sent;
                address = _yield$utils$getLocat.address;
                week = [i18n.tc("576"), i18n.tc("577"), i18n.tc("578"), i18n.tc("579"), i18n.tc("580"), i18n.tc("581"), i18n.tc("582")];
                _context.next = 10;
                return addWatermark(tempCanvas, ["".concat(address), "".concat(new Date().Format('HH:mm')), "".concat(new Date().Format('YYYY-MM-DD')), "".concat(week[new Date().getDay()]), "".concat(store === null || store === void 0 ? void 0 : (_store$state = store.state) === null || _store$state === void 0 ? void 0 : (_store$state$globalSt = _store$state.globalStore) === null || _store$state$globalSt === void 0 ? void 0 : (_store$state$globalSt2 = _store$state$globalSt.user) === null || _store$state$globalSt2 === void 0 ? void 0 : _store$state$globalSt2.name)]);
              case 10:
                canvas = _context.sent;
                // 3.调用方法3： 写入水印到Canvas
                // canvas转成img
                img = convasToImg(canvas, file.type); // 4. 调用方法4：把Canvas转换为image文件
                // 被canvas转换为文件
                newFile = base64ToFile(img.src, file.name); // 5.调用方法5：被image转换为File文件
                resolve(newFile);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
}
/**
 * 文件转base64
 * @param  file 文件流
 * @param  callback 回调函数
 */
function fileByBase64(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    // 传入一个参数对象即可得到基于该参数对象的文本内容
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      // target.result 该属性表示目标对象的DataURL
      resolve(e.target.result);
    };
  });
}

/**
 * Base64转成canvas
 * @param  base64
 */
function imgToCanvas(_x2) {
  return _imgToCanvas.apply(this, arguments);
}
function _imgToCanvas() {
  _imgToCanvas = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(base64) {
    var img, canvasEl, ratio;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // 创建img元素
            img = document.createElement('img');
            img.setAttribute('src', base64);
            _context2.next = 4;
            return new Promise(function (resolve) {
              return img.onload = resolve;
            });
          case 4:
            // 创建canvas DOM元素，并设置其宽高和图片一样
            canvasEl = document.createElement('canvas');
            ratio = window.devicePixelRatio || 1;
            canvasEl.style.width = img.width + 'px';
            canvasEl.style.height = img.height + 'px';
            canvasEl.width = img.width;
            canvasEl.height = img.height;

            // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
            canvasEl.getContext('2d').drawImage(img, 0, 0);
            return _context2.abrupt("return", canvasEl);
          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _imgToCanvas.apply(this, arguments);
}
function loadImg(_x3, _x4, _x5) {
  return _loadImg.apply(this, arguments);
}
/**
 * canvas添加水印
 * @param  canvas 对象
 * @param text 水印文字
 */
function _loadImg() {
  _loadImg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, width, height) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve) {
              var img = new Image(width, height);
              img.src = url;
              img.onload = function () {
                return resolve(img);
              };
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _loadImg.apply(this, arguments);
}
function addWatermark(_x6, _x7) {
  return _addWatermark.apply(this, arguments);
}
/**
 * canvas转成img
 * @param {canvas对象} canvas
 */
function _addWatermark() {
  _addWatermark = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(canvas, textArr) {
    var ctx, canvasWidth, fontBl, fontSize, fontSizeBl, lineHeight, imgBl, x, y, isSame, LocateImg, CameraImg, twidth, lwidth;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            /**
             * @type CanvasRenderingContext2D
             */
            ctx = canvas.getContext('2d');
            canvasWidth = canvas.width;
            fontBl = 0.03;
            fontSize = Math.floor(canvasWidth * fontBl); // 以24px为基础字体的比例
            fontSizeBl = fontSize / 24;
            lineHeight = 24 * fontSizeBl;
            imgBl = fontSize / 24; // 图片比例
            x = 10 * fontSizeBl;
            y = ctx.canvas.height - 10 * fontSizeBl; // let octree = new OctreeNode(0)
            // let imageData = ctx.getImageData(0, y - lineHeight * 3, canvasWidth / 2, lineHeight * 3).data
            // octree.buildOctree(imageData, 8)
            // let res = octree.colorsStats(octree)
            // console.log('AutoConsole: addWatermark -> res', res)
            // let colorRgb = colorHexToRgb('#' + res.maxColor)
            // const colorWhite = colorHexToRgb('#ffffff')
            // const similarity = colorDistance(colorRgb, colorWhite)
            isSame = false;
            _context4.next = 12;
            return loadImg(require('@/assets/png/locate.png'), 14 * imgBl, 14 * imgBl);
          case 12:
            LocateImg = _context4.sent;
            _context4.next = 15;
            return loadImg(require('@/assets/png/camera.png'), 20 * imgBl, 17 * imgBl);
          case 15:
            CameraImg = _context4.sent;
            // ctx.clearRect(0, 0, canvas.width, canvas.height)
            // 地点
            ctx.drawImage(LocateImg, x, y - LocateImg.height + 3 * imgBl, LocateImg.width, LocateImg.height);
            ctx.fillStyle = isSame ? '#222222' : '#ffffff';
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'start';
            ctx.font = "".concat(fontSize / 2, "px Arial");
            ctx.fillText(textArr[0], x + LocateImg.width + 5, y - lineHeight * 0 - 5);
            // 时间
            ctx.font = "".concat(fontSize, "px Arial");
            ctx.fillText(textArr[1], x - 3, y - lineHeight * 1 - 5);
            twidth = ctx.measureText(textArr[1]).width;
            ctx.font = "".concat(fontSize, "px Arial");
            ctx.fillText('|', x + twidth + 1, y - lineHeight * 1 - 6);
            lwidth = ctx.measureText('|').width + twidth + 6 * fontSizeBl;
            ctx.font = "".concat(fontSize / 2.4, "px Arial");
            ctx.fillText(textArr[2], x + lwidth, y - lineHeight * 1 - 5 * fontSizeBl - 5 * fontSizeBl);
            ctx.fillText(textArr[3], x + lwidth, y - lineHeight * 1 - 5 * fontSizeBl + 8 * fontSizeBl);
            // 人名
            ctx.drawImage(CameraImg, x, y - lineHeight * 2 - CameraImg.height + 3 * imgBl, CameraImg.width, CameraImg.height);
            ctx.font = "".concat(fontSize / 2, "px Arial");
            ctx.fillText(textArr[4], x + CameraImg.width + 7, y - lineHeight * 2 - CameraImg.height / 2 + 4 * fontSizeBl);
            return _context4.abrupt("return", canvas);
          case 35:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _addWatermark.apply(this, arguments);
}
function convasToImg(canvas, type) {
  // 新建Image对象，可以理解为DOM
  var image = new Image();
  // canvas.toDataURL 返回的是一串Base64编码的URL
  // 指定格式 PNG
  image.src = canvas.toDataURL(type);
  return image;
}
/**
 * @param urlData  base64
 * @param fileName 文件名称
 * @returns {File}
 */
function base64ToFile(urlData, fileName) {
  var arr = urlData.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bytes = atob(arr[1]); // 解码base64
  var n = bytes.length;
  var ia = new Uint8Array(n);
  while (n--) {
    ia[n] = bytes.charCodeAt(n);
  }
  return new File([ia], fileName, {
    type: mime
  });
}
// 小于100 等于相似
var colorDistance = function colorDistance(arrRGB1, arrRGB2) {
  var _arrRGB = _slicedToArray(arrRGB1, 3),
    r1 = _arrRGB[0],
    g1 = _arrRGB[1],
    b1 = _arrRGB[2];
  var _arrRGB2 = _slicedToArray(arrRGB2, 3),
    r2 = _arrRGB2[0],
    g2 = _arrRGB2[1],
    b2 = _arrRGB2[2];
  var rmean = (r1 + r2) / 2;
  var r = r1 - r2;
  var g = g1 - g2;
  var b = b1 - b2;
  return Math.sqrt((2 + rmean / 256) * r * r + 4 * g * g + (2 + (255 - rmean) / 256) * b * b);
};
function colorHexToRgb(color) {
  var sColor = color.toLowerCase();
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  var sColorChange = [];
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#';
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值

    for (var _i = 1; _i < 7; _i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(_i, _i + 2)));
    }
  }
  return sColorChange;
}